import { useDataSubmit } from 'Simple/Data.js'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'signin',
    viewPath: props.viewPath,
  })
  return function onSubmit() {
    submit({ type: 'signin' })
  }
}
